import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtAddressConfirmationCtrl($scope, $timeout, ShoppingCartStore) {
  var self = this;
  this.isOrderEditPage = $scope.isOrderEditPage;
  this.displaySuggestedModal = true;
  this.displayEditModal = false;

  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.suggestedAddress = function () {
    return $scope.suggestedAddressObj();
  };

  var closeModal = this.close.bind(this);

  this.close = function () {
    $scope.setShippingAddressToOriginalAddress();
    $scope.populateAddress();
    closeModal();
    $timeout(
      function () {
        this.displaySuggestedModal = true;
        this.displayEditModal = false;
      }.bind(this),
      100
    );
  };

  this.setToSuggestedAddress = function () {
    $scope.setShippingAddressToSuggestedAddress();
    $scope.populateAddress();
    closeModal();
  };

  this.setToOriginalAddress = function () {
    $scope.setShippingAddressToOriginalAddress();
    $scope.populateAddress();
    closeModal();
  };

  this.navigation = function () {
    $timeout(
      function () {
        this.displaySuggestedModal = false;
        this.displayEditModal = true;
      }.bind(this),
      100
    );
  };
}

App.controller('LtAddressConfirmationCtrl', ['$scope', '$timeout', 'ShoppingCartStore', LtAddressConfirmationCtrl]);
